import { render, staticRenderFns } from "./ElRichText.vue?vue&type=template&id=7a077e7c"
import script from "./ElRichText.vue?vue&type=script&lang=js"
export * from "./ElRichText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports